import { Component, DestroyRef, inject, input, OnInit, output, ChangeDetectionStrategy } from '@angular/core';
import { ReactiveFormsModule, UntypedFormControl } from '@angular/forms';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { debounceTime } from 'rxjs/operators';

@Component({
  selector: 'quantity-control',
  templateUrl: './quantity-control.component.html',
  styleUrls: ['./quantity-control.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [ReactiveFormsModule],
  host: {
    '[class.compact]': 'isCompact()',
  },
})
export class QuantityControlComponent implements OnInit {

  qtyControl: UntypedFormControl;
  readonly initialValue = input<number>(1);
  /** A smaller control, for a row it shares with other buttons. */
  readonly isCompact = input(false);
  readonly valueChanged = output<number>();

  private readonly destroyRef = inject(DestroyRef);

  constructor() {
  }

  ngOnInit(): void {
    this.qtyControl = new UntypedFormControl(this.initialValue());
    this.qtyControl.valueChanges
      .pipe(
        debounceTime(500),
        takeUntilDestroyed(this.destroyRef),
      )
      .subscribe(value => {
        if (value < 1) {
          this.setValue(1);
          return;
        }
        this.valueChanged.emit(value);
      });
  }

  incrementQty() {
    let qty = this.getValue();
    this.setValue(++qty);
  }

  decrementQty() {
    let qty = this.getValue();
    if (qty === 1) {
      return;
    }
    if (qty < 1) {
      this.setValue(1);
      return;
    }

    this.setValue(--qty);
  }

  setValue(value: number, emitEvent: boolean = true) {
    this.qtyControl.setValue(value, { emitEvent });
  }

  getValue() {
    return this.qtyControl.value;
  }
}
